module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_innterthal-5e65f71af6c25a9694f3784ccd292baa.png";